import { create } from "zustand";

interface UserProfileState {
  userProfile: any;
  setUserProfile: (profile: any) => void;
  token: string | null;
  setToken: (token: string | null) => void;
}

export const useUserProfileStore = create<UserProfileState>((set) => ({
  userProfile: null,
  setUserProfile: (profile) => set({ userProfile: profile }),
  token: null,
  setToken: (token) => set({ token }),
}));
